import React, { useEffect, useState } from "react";
import { VersaLogo } from "./Logo";
import { Button } from "@/components/ui/button";
import { Menu, X } from "lucide-react";

const links = [
  { label: "About", href: "/#about" },
  { label: "Products", href: "/#products" },
  { label: "Customize", href: "/#customize" },
  { label: "Directors", href: "/directors" },
  { label: "Sustainability", href: "/#sustainability" },
  { label: "Industries", href: "/#industries" },
  { label: "Contact", href: "/#contact" },
];

export const Navbar = ({ onQuote }) => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
    // setScrolled is a stable setter; effect runs once on mount.
  }, []);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 left-0 right-0 z-40 transition-all duration-300 ${
        scrolled
          ? "bg-white/85 backdrop-blur-xl border-b border-neutral-200/70 shadow-sm"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 md:px-10 h-16 md:h-20 flex items-center justify-between">
        <a href="#top" className="flex items-center" data-testid="nav-home">
          <VersaLogo size={40} />
        </a>
        <nav className="hidden lg:flex items-center gap-7">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-${l.label.toLowerCase()}`}
              className="text-sm font-medium text-neutral-700 hover:text-neutral-900 transition-colors relative after:content-[''] after:absolute after:-bottom-1.5 after:left-0 after:right-0 after:mx-auto after:w-0 after:h-[2px] after:vc-gradient hover:after:w-full after:transition-all"
            >
              {l.label}
            </a>
          ))}
        </nav>
        <div className="hidden lg:flex items-center gap-3">
          <a
            href="/catalogue.pdf"
            target="_blank"
            rel="noreferrer"
            data-testid="nav-catalogue"
            className="text-sm font-semibold text-neutral-700 hover:text-neutral-900"
          >
            Catalogue ↗
          </a>
          <Button
            data-testid="nav-quote-btn"
            onClick={onQuote}
            className="vc-gradient text-white hover:opacity-95 rounded-full px-5 h-10 font-semibold border-0"
          >
            Request a Quote
          </Button>
        </div>

        <button
          className="lg:hidden p-2 text-neutral-900"
          onClick={() => setOpen(!open)}
          data-testid="nav-mobile-toggle"
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-white border-t border-neutral-200 shadow-md">
          <div className="px-5 py-4 flex flex-col gap-3">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="text-base font-medium text-neutral-800 py-2 border-b border-neutral-100"
                data-testid={`nav-mobile-${l.label.toLowerCase()}`}
              >
                {l.label}
              </a>
            ))}
            <Button
              onClick={() => { setOpen(false); onQuote(); }}
              className="vc-gradient text-white rounded-full font-semibold mt-2"
              data-testid="nav-mobile-quote-btn"
            >
              Request a Quote
            </Button>
          </div>
        </div>
      )}
    </header>
  );
};
